document.addEventListener("Searchanise.Loaded", function () {
  (function ($) {
    var facets = [];

    $(document).on('keyup', '.snize-product-filters-search input.snize-filter-input', function() {
      var value = this.value.toLowerCase().trim();
      var filters_block_list = $(this).closest('.snize-product-filters-block').find('ul.snize-product-filters-list');
      var filters_dropdown_list = $(this).closest('.snize-filters-dropdown-content').find('ul.snize-product-filters-list');

      $(filters_block_list).children('li:not(.snize-product-filters-search)').show().filter(function() {
        return $(this).children('label').text().toLowerCase().trim().indexOf(value) == -1;
      }).hide();

      $(filters_dropdown_list).children('li:not(.snize-product-filters-search)').show().filter(function() {
        return $(this).children('label').text().toLowerCase().trim().indexOf(value) == -1;
      }).hide();
    });

    $(document).on("Searchanise.ResultsUpdated", function (event, container) {
      if (!facets.length) {
        facets = Searchanise.GetWidgets().searchResults.getPrevData().result.facets;
      }

      facets.forEach(function(facet) {
        if (facet.type == 'select' && facet.buckets.length > 5) {
          var filter_id = 'product_filters_search_' + facet.attribute;
          var html = '<div class="snize-product-filters-search"><input type="text" class="snize-filter-input" id="' + filter_id + '" name="product_filters_search_' + facet.attribute + '" placeholder="Type here to search" /></div>';

          if (!$('.snize-product-filters-search', '#snize_filters_block_' + facet.attribute).length) {
            $('.snize-product-filters-list', '#snize_filters_block_' + facet.attribute).prepend(html);
          }

          if (!$('.snize-product-filters-search', '#snize_filters_dropdown_' + facet.attribute).length) {
            $('.snize-product-filters-list', '#snize_filters_dropdown_' + facet.attribute).prepend(html);
          }
        }
      });
    });
  })(window.Searchanise.$);
});
